<template>
  <svg width="18" height="18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13 1L1 13M1 1l12 12" stroke="#DB545F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>
